import styled from "styled-components";

const SubTitle = styled.div`
  width: max-content;
  @media (max-width: 575px) {
    width: 100%;
  }
`;
export default SubTitle;
